
// Generated by common/web/keyman-version/build.sh
//
// Note:  does not use the 'default' keyword so that the export name is
// correct when converted to a CommonJS module with `esbuild`.
export class KEYMAN_VERSION {
  static readonly VERSION = "20.0.7";
  static readonly VERSION_RELEASE ="20.0";
  static readonly VERSION_MAJOR = "20";
  static readonly VERSION_MINOR = "0";
  static readonly VERSION_PATCH = "7";
  static readonly TIER ="alpha";
  static readonly VERSION_TAG = "-alpha";
  static readonly VERSION_WITH_TAG = "20.0.7-alpha";
  static readonly VERSION_ENVIRONMENT = "alpha";
  static readonly VERSION_GIT_TAG = "release@20.0.7-alpha";
}

// Also provides it as a 'default' export.
export default KEYMAN_VERSION;
  
